module.exports = __webpack_public_path__ + "img/ic_4_digit_pin.29cf9f19.svg";